// RAIL — horizontal snap cards. Q&A cards on a horizontal scroll rail with
// scroll-snap; every answer is visible (no accordion). Header row pairs the
// title with a "Scroll" hint. All colors/fonts/radii via ctx.v.
function itemHtml(ctx, it) {
    return `<div class="fq-card"${ctx.reveal(it.idx)}>
  <span class="fq-num">${it.num}</span>
  <h3 class="fq-q">${it.q}</h3>
  <div class="fq-a">${it.aHtml}</div>
</div>`;
}
const rail = {
    id: 'rail',
    name: 'Rail',
    tag: 'Horizontal cards',
    styleTag: 'Swipeable',
    description: 'Q&A cards on a horizontal rail with scroll-snap. Swipes naturally on touch, scrolls on desktop \u2014 an FAQ that behaves like a story row.',
    layout: 'cards',
    defaultAccent: '#dd5784',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    <span class="fq-hint" aria-hidden="true">${ctx.t('scroll')} ${ctx.svg.arrowRight}</span>
  </div>
  <div class="fq-rail">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:880px;margin:0 auto}
.FQM .fq-head{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:10px;margin-bottom:22px}
.FQM .fq-title{margin:0;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.015em;color:${ctx.v.ink}}
.FQM .fq-hint{display:inline-flex;align-items:center;gap:7px;font-size:13px;color:${ctx.v.sub}}
.FQM .fq-hint .fq-svg{width:10px;height:10px}
.FQM .fq-rail{display:flex;gap:14px;overflow-x:auto;scroll-snap-type:x mandatory;padding:4px 4px 16px}
.FQM .fq-card{flex:0 0 280px;scroll-snap-align:start;padding:24px 22px;background:${ctx.v.card};border:1px solid ${ctx.v.border};border-radius:${ctx.v.radiusCard}}
.FQM .fq-num{font-family:${ctx.v.mono};font-size:12px;letter-spacing:0.06em;color:${ctx.v.accent}}
.FQM .fq-q{margin:10px 0 8px;font-size:16.5px;font-weight:600;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-a{font-size:14px;line-height:1.65;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default rail;
